/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from './index';
import { AnyAction } from 'redux';
import { UniversalTrackerBlueprintMin } from '../types/universalTracker';


type State = ReduxStateLoadable<UniversalTrackerBlueprintMin[]> & { initiativeId?: string }

const getDefaultState = (): State => ({
  data: undefined,
  initiativeId: undefined,
  loaded: false,
  errored: false,
  errorMessage: ''
});

const initiativeBlueprintQuestions = (
  state: State = getDefaultState(),
  action: AnyAction,
): State => {

  switch (action.type) {
    case actionTypes.LOADING_INITIATIVE_BLUEPRINT_QUESTIONS:
      return {
        ...state,
        data: undefined,
        initiativeId: action.initiativeId,
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_INITIATIVE_BLUEPRINT_QUESTIONS:
      return {
        ...state,
        data: undefined,
        initiativeId: action.initiativeId,
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.LOADED_INITIATIVE_BLUEPRINT_QUESTIONS:
      return {
        ...state,
        data: action.data,
        initiativeId: action.initiativeId,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    default:
      return state;
  }
}

export default initiativeBlueprintQuestions;
